function isPlainObject(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

export function normalizeWorkingYears(value: unknown): number[] | null {
  if (!Array.isArray(value) || !value.length) {
    return null;
  }

  const years = value
    .map((item) => Number(item))
    .filter((year) => Number.isFinite(year) && year > 0)
    .map((year) => Math.trunc(year));

  if (!years.length) {
    return null;
  }

  return Array.from(new Set(years)).sort((a, b) => a - b);
}

/**
 * Pull working_years from login / me / abilities / cai-dat payloads.
 */
export function extractWorkingYears(payload: unknown): number[] | null {
  if (!isPlainObject(payload)) {
    return null;
  }

  const direct = normalizeWorkingYears(
    payload.working_years ?? payload.workingYears
  );
  if (direct) {
    return direct;
  }

  const data = payload.data;
  if (isPlainObject(data)) {
    const fromData = normalizeWorkingYears(
      data.working_years ?? data.workingYears
    );
    if (fromData) {
      return fromData;
    }

    const user = data.user;
    if (isPlainObject(user)) {
      const fromUser = normalizeWorkingYears(
        user.working_years ?? user.workingYears
      );
      if (fromUser) {
        return fromUser;
      }
    }
  }

  const extra = payload.extra;
  if (isPlainObject(extra)) {
    const fromExtra = normalizeWorkingYears(
      extra.working_years ?? extra.workingYears
    );
    if (fromExtra) {
      return fromExtra;
    }
  }

  const user = payload.user;
  if (isPlainObject(user)) {
    return normalizeWorkingYears(user.working_years ?? user.workingYears);
  }

  return null;
}

export function getFallbackWorkingYears(): number[] {
  return [new Date().getFullYear()];
}

/** Clamp a year into the selectable working_years list. */
export function clampYearToWorkingYears(
  year: string | number | null | undefined,
  years: number[]
): string {
  const list = years.length ? years : getFallbackWorkingYears();
  const parsed = Number(year);

  if (Number.isFinite(parsed) && list.includes(Math.trunc(parsed))) {
    return String(Math.trunc(parsed));
  }

  const current = new Date().getFullYear();
  if (list.includes(current)) {
    return String(current);
  }

  return String(list[list.length - 1]);
}
